import { useEffect, useRef } from 'react'
import { useStore } from '../store/useStore'

const ICON = '/icons/icon-192x192.png'


export function useAlertNotifications() {
  const alerts          = useStore((s) => s.alerts)
  const setSelectedSymbol = useStore((s) => s.setSelectedSymbol)
  const setActiveTab    = useStore((s) => s.setActiveTab)

  // IDs that have already been notified — persisted across re-renders via ref
  const notifiedIds   = useRef<Set<string>>(new Set())
  const isInitialized = useRef(false)

  useEffect(() => {
    if (!isInitialized.current) {
      // First mount: mark all current (historical) alerts as already notified
      // so we only fire notifications for alerts that arrive AFTER page load.
      notifiedIds.current = new Set(alerts.map((a) => a.id))
      isInitialized.current = true
      return
    }

    if (!('Notification' in window) || Notification.permission !== 'granted') return

    for (const alert of alerts) {
      if (notifiedIds.current.has(alert.id)) continue
      notifiedIds.current.add(alert.id)

      const notif = new Notification(
        `TradeVista AI — ${alert.symbol}`,
        {
          body: alert.message,
          icon: ICON,
          tag:  alert.id,   // deduplicate same-id notifications
          badge: ICON,
          lang: 'ja',
          data: { symbol: alert.symbol },
        },
      )

      notif.onclick = () => {
        window.focus()
        setSelectedSymbol(alert.symbol)
        setActiveTab(alert.type === 'ai_entry_signal' ? 'analysis' : 'dashboard')
        notif.close()
      }
    }
  }, [alerts, setSelectedSymbol, setActiveTab])
}
